module.exports = __webpack_public_path__ + "img/circle_overlay.4b7f253d.jpg";